import React from "react";

const Navigation = ({ sectionList, selectedSection, setSelectedSection }) => {
  const NavigationType = ({ type }) => (
    <ul className="mt-4">
      {sectionList[type].map((section) => (
        <li
          className={selectedSection === section ? "active pl-4" : "pl-4"}
          onClick={() => setSelectedSection(section)}
        >
          <b></b>
          <p className={selectedSection === section ? "clipped" : undefined}>
            {selectedSection === section ? <b>{section}</b> : section}
          </p>
        </li>
      ))}
    </ul>
  );
  return (
    <aside
      role="secondary-navbar"
      className="max-h-[calc(100vh-12rem)] overflow-auto"
    >
      <h4 className="mt-6">Getting Started</h4>
      <NavigationType type="start" />
      <h4 className="mt-6">Semantic</h4>
      <NavigationType type="semantic" />
      <h4 className="mt-6">Components</h4>
      <NavigationType type="components" />
    </aside>
  );
};

export default Navigation;
